import { useEffect } from 'react';

export interface ShortcutHandlers {
  onIncreaseFont?: () => void;
  onDecreaseFont?: () => void;
  onSplit1?: () => void;
  onSplit2?: () => void;
  onSplit3?: () => void;
  onToggleFullscreen?: () => void;
  onToggleAutoScroll?: () => void;
  onSlowerSpeed?: () => void;
  onFasterSpeed?: () => void;
  onNextPage?: () => void;
  onPrevPage?: () => void;
  onOpenShortcutsModal?: () => void;
}

export function useKeyboardShortcuts(handlers: ShortcutHandlers, enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignore key events if target is an input element, textarea, or contentEditable
      const target = e.target as HTMLElement | null;
      if (
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT' ||
          target.isContentEditable)
      ) {
        return;
      }

      // Do not trigger hotkeys if modifying keys are pressed (Ctrl, Meta, Alt)
      if (e.ctrlKey || e.metaKey || e.altKey) {
        return;
      }

      const key = e.key.toLowerCase();

      switch (key) {
        case '1':
          e.preventDefault();
          handlers.onSplit1?.();
          break;
        case '2':
          e.preventDefault();
          handlers.onSplit2?.();
          break;
        case '3':
          e.preventDefault();
          handlers.onSplit3?.();
          break;
        case 'n':
          e.preventDefault();
          handlers.onIncreaseFont?.();
          break;
        case 'm':
          e.preventDefault();
          handlers.onDecreaseFont?.();
          break;
        case 'f':
          e.preventDefault();
          handlers.onToggleFullscreen?.();
          break;
        case 'w':
          e.preventDefault();
          handlers.onToggleAutoScroll?.();
          break;
        case 'q':
          e.preventDefault();
          handlers.onSlowerSpeed?.();
          break;
        case 'e':
          e.preventDefault();
          handlers.onFasterSpeed?.();
          break;
        case '.':
        case '>':
          e.preventDefault();
          handlers.onNextPage?.();
          break;
        case ',':
        case '<':
          e.preventDefault();
          handlers.onPrevPage?.();
          break;
        case '?':
          e.preventDefault();
          handlers.onOpenShortcutsModal?.();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handlers, enabled]);
}
